import { render, staticRenderFns } from "./PagedListPopularPlacesNative.vue?vue&type=template&id=71252713&"
import script from "./PagedListPopularPlacesNative.vue?vue&type=script&lang=js&"
export * from "./PagedListPopularPlacesNative.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports